import { NavLink } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const baseNav = [
  { label: 'Dashboard', path: '/dashboard' },
  { label: 'Calendar', path: '/calendar' },
  { label: 'Booking List', path: '/bookings' },
  { label: 'Reports', path: '/reports' },
  { label: 'Archive', path: '/archive' },
];

export default function Sidebar({ isOpen, onClose }) {
  const { user } = useAuth();
  const navItems = [...baseNav];
  if (user?.role === 'ADMIN') {
    navItems.push({ label: 'Admin Config', path: '/admin' });
  }

  return (
    <aside className={`sidebar ${isOpen ? 'open' : ''}`}>
      <div className="brand" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '0.8rem' }}>
        <div style={{
          width: '40px',
          height: '40px',
          backgroundColor: 'white',
          borderRadius: '8px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '2px',
          flexShrink: 0
        }}>
          <img 
            src="/Media_Logo.png" 
            alt="Delta Media" 
            style={{ 
              width: '100%', 
              height: '100%', 
              objectFit: 'contain',
              borderRadius: '6px'
            }} 
          />
        </div>
        <div style={{ flexGrow: 1 }}>
          DELTA MEDIA
          <div style={{ fontSize: '0.7rem', marginTop: '0.2rem', color: 'rgba(255,255,255,0.75)' }}>
            Booking System
          </div>
        </div>
        <button 
          onClick={onClose}
          style={{ 
            background: 'none', 
            border: 'none', 
            color: 'white', 
            fontSize: '1.5rem', 
            cursor: 'pointer',
            display: 'var(--nav-width) === "0px" ? "block" : "none"' 
          }}
          className="mobile-close-btn"
        >
          &times;
        </button>
      </div>
      <nav>
        <a 
          href={process.env.REACT_APP_MASTER_PORTAL_URL || "http://localhost:5173"} 
          style={{ 
            display: 'flex', 
            alignItems: 'center', 
            padding: '12px 20px', 
            color: '#38bdf8', 
            textDecoration: 'none', 
            fontWeight: 'bold',
            borderBottom: '1px solid rgba(255,255,255,0.1)',
            marginBottom: '10px'
          }}
        >
          <span style={{ marginRight: '10px' }}>🏠</span>
          Master Portal
        </a>
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) => (isActive ? 'active' : '')}
            onClick={() => {
              if (window.innerWidth <= 1024) onClose();
            }}
          >
            {item.label}
          </NavLink>
        ))}
      </nav>

      <div className="sidebar-footer" style={{ 
        marginTop: 'auto', 
        padding: '1.2rem', 
        borderTop: '1px solid rgba(255,255,255,0.1)',
        display: 'flex',
        alignItems: 'center',
        gap: '1rem'
      }}>
        <div style={{
          width: '45px',
          height: '45px',
          backgroundColor: 'white',
          borderRadius: '12px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '4px',
          boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
        }}>
          <img 
            src="/DigiTech_logo.png" 
            alt="Logo" 
            style={{ 
              width: '100%', 
              height: '100%', 
              objectFit: 'contain',
              borderRadius: '8px'
            }} 
          />
        </div>
        <div style={{ 
          display: 'flex', 
          flexDirection: 'column',
          lineHeight: '1.2'
        }}>
          <span style={{ 
            fontSize: '0.65rem', 
            color: 'rgba(255,255,255,0.5)', 
            fontWeight: '700',
            letterSpacing: '0.05rem' 
          }}>
            POWERED BY
          </span>
          <span style={{ 
            fontSize: '0.85rem', 
            color: 'rgba(255,255,255,0.9)', 
            fontWeight: '800',
            letterSpacing: '0.02rem'
          }}>
            DELTA DIGITECH
          </span>
        </div>
      </div>
    </aside>
  );
}

